import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./constants";

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chat with Kiara on WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-charcoal/85 text-gold shadow-[0_8px_32px_rgba(0,0,0,0.5)] backdrop-blur-md transition-colors duration-500 hover:bg-gold hover:text-ebony"
  >
    <MessageCircle size={22} strokeWidth={1.5} />
    <span className="absolute right-full mr-4 hidden whitespace-nowrap border border-champagne/20 bg-charcoal/90 px-4 py-2 text-[10px] uppercase tracking-[0.25em] text-cream/80 backdrop-blur-md group-hover:block">
      Chat with Kiara
    </span>
  </a>
);

export default FloatingWhatsApp;
